import React from "react";
import loadable from "@loadable/component";
import Loader from "../Loader";

export default loadable(() => import("./ComposerForm"), { fallback: <Loader margin="auto" /> });
